import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';

import MegamenuList from './MegamenuList';

import {
  Wrapper,
  Content,
  Main,
  Aside,
  Title,
  TitleLink,
  TitleLinkExternal,
  Box,
  Item,
  ItemExternal,
  Imagebox,
  Image,
  Text,
  Arrow
} from './Megamenu.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IMAGE_PLACEHOLDER from 'assets/Images/placeholder-50x50.png';

function Megamenu({ data = [], opened = false }) {
  const theme = useTheme();

  const renderItemInner = data => {
    const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
    let currentImage = data.thumbnail || data.image;
    let currentImageMatch;
    if (currentImage) {
      currentImageMatch = currentImage.match(regExp);
      if (currentImageMatch && currentImageMatch[1] && currentImageMatch[2])
        currentImage = `${currentImageMatch[1]}_${theme.megamenu.image.width}x${theme.megamenu.image.height}${currentImageMatch[2]}`;
    }

    return (
      <>
        <Imagebox>
          <Image
            theme={theme.megamenu.image}
            src={currentImage || IMAGE_PLACEHOLDER}
            loading='lazy'
            alt={data.title}
          />
        </Imagebox>
        <Text theme={theme.megamenu.text}>
          {data.title}
          <Arrow theme={theme.megamenu.arrow}>
            <FontAwesomeIcon icon={theme.megamenu.arrow.faIcon} />
          </Arrow>
        </Text>
      </>
    );
  };

  const renderAside = aside => {
    return (
      <>
        {aside && aside.data && aside.data.length > 0 ? (
          <Aside theme={theme.megamenu.aside}>
            <Title theme={theme.megamenu.title}>
              {aside && aside.title ? (
                (aside.slug && /(http(s?)):\/\//gi.test(aside.slug)) ||
                (aside.url && /(http(s?)):\/\//gi.test(aside.url)) ||
                aside.url_outside ? (
                  <TitleLinkExternal
                    href={aside.slug || aside.url || aside.url_outside}
                    target={
                      aside._blank || aside.url_blank || aside.url_outside_blank
                        ? '_blank'
                        : '' || aside.target || ''
                    }
                    rel={
                      aside.nofollow ||
                      aside.url_nofollow ||
                      aside.url_outside_nofollow
                        ? 'nofollow'
                        : '' || aside.rel || ''
                    }
                  >
                    {aside.title}
                  </TitleLinkExternal>
                ) : (
                  <TitleLink
                    smooth
                    to={
                      aside.slug &&
                      (aside.slug[0] === '/' || aside.slug[0] === '#')
                        ? aside.slug
                        : `/${aside.slug}`
                    }
                  >
                    {aside.title}
                  </TitleLink>
                )
              ) : (
                <FormattedMessage id='MEGAMENU.SEE_MORE' />
              )}
            </Title>
            <MegamenuList data={aside.data} />
          </Aside>
        ) : (
          ''
        )}
      </>
    );
  };

  const mainData = data && data[0];
  const asideData = data && data[1];

  return (
    <Wrapper
      theme={theme.megamenu.wrapper}
      opened={opened ? opened.toString() : undefined}
    >
      <Content>
        <Main theme={theme.megamenu.main}>
          <Title theme={theme.megamenu.title}>
            {mainData && mainData.title ? (
              (mainData.slug && /(http(s?)):\/\//gi.test(mainData.slug)) ||
              (mainData.url && /(http(s?)):\/\//gi.test(mainData.url)) ||
              mainData.url_outside ? (
                <TitleLinkExternal
                  href={mainData.slug || mainData.url || mainData.url_outside}
                  target={
                    mainData._blank ||
                    mainData.url_blank ||
                    mainData.url_outside_blank
                      ? '_blank'
                      : '' || mainData.target || ''
                  }
                  rel={
                    mainData.nofollow ||
                    mainData.url_nofollow ||
                    mainData.url_outside_nofollow
                      ? 'nofollow'
                      : '' || mainData.rel || ''
                  }
                >
                  {mainData.title}
                </TitleLinkExternal>
              ) : (
                <TitleLink
                  smooth
                  to={
                    mainData.slug && mainData.slug[0] === '/'
                      ? mainData.slug
                      : `/${mainData.slug}`
                  }
                >
                  {mainData.title}
                </TitleLink>
              )
            ) : (
              <FormattedMessage id='MEGAMENU.NEW_ARTICLES_AND_OFFERS' />
            )}
          </Title>
          <Box>
            {mainData &&
              mainData.data &&
              mainData.data.map((item, key) =>
                (item.slug && /(http(s?)):\/\//gi.test(item.slug)) ||
                (item.url && /(http(s?)):\/\//gi.test(item.url)) ||
                item.url_outside ? (
                  <ItemExternal
                    theme={theme.megamenu.item}
                    key={key}
                    title={item.title}
                    href={item.slug || item.url || item.url_outside}
                    target={
                      item._blank || item.url_blank || item.url_outside_blank
                        ? '_blank'
                        : '' || item.target || ''
                    }
                    rel={
                      item.nofollow ||
                      item.url_nofollow ||
                      item.url_outside_nofollow
                        ? 'nofollow'
                        : '' || item.rel || ''
                    }
                  >
                    {renderItemInner(item)}
                  </ItemExternal>
                ) : (
                  <Item
                    theme={theme.megamenu.item}
                    key={key}
                    title={item.title}
                    smooth
                    to={
                      item.slug &&
                      (item.slug[0] === '/' || item.slug[0] === '#')
                        ? item.slug
                        : `/${item.slug}`
                    }
                  >
                    {renderItemInner(item)}
                  </Item>
                )
              )}
          </Box>
        </Main>
        {renderAside(asideData)}
      </Content>
    </Wrapper>
  );
}

export default Megamenu;
